import { restClient } from '@/Core'

import { toNode } from '../Helpers/diskResponse'

import type { DiskNode } from '../Contracts/DiskNode'
import type { DiskUploadConflict } from '../Contracts/DiskUpload'

/** Великий файл на повільному зв'язку не вкладається в типові 30 с клієнта. */
export const DISK_UPLOAD_REQUEST_TIMEOUT_MS = 10 * 60 * 1000

export interface UploadDiskFileParams {
    parent: string
    file: File
    conflict: DiskUploadConflict
    relativePath?: string
    sha256?: string | null
    signal?: AbortSignal
}

/**
 * Завантаження одним запитом (до `DISK_SIMPLE_UPLOAD_MAX_MIB`):
 * `POST /services/disk/files`, multipart `parent`, `file`, `conflict`,
 * `relativePath`, `sha256`. Більші файли менеджер завантажень везе шматками.
 */
export const UploadDiskFileTask = async ({
    parent,
    file,
    conflict,
    relativePath,
    sha256,
    signal,
}: UploadDiskFileParams): Promise<DiskNode> => {
    const body = new FormData()
    body.append('parent', parent)
    body.append('conflict', conflict)
    if (relativePath) body.append('relativePath', relativePath)
    if (sha256) body.append('sha256', sha256)
    body.append('file', file, file.name)

    const response = (await restClient.post(
        '/services/disk/files',
        { body, timeout: DISK_UPLOAD_REQUEST_TIMEOUT_MS, ...(signal ? { signal } : {}) },
        { isNotHeaderAddContentType: true }
    )) as unknown

    return toNode(response)
}
